<template>
  <div>
    <div class="content">
      <div class="md-layout">
        <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
        >
          <md-card class="md-card-plain">
            <md-card-header>
              <h4 class="title"><b>Mayai Customer List</b></h4>
            </md-card-header>
            <md-card-content>
              <template>
                <div
                  style="display:inline-flex; width: 100%; margin-bottom: 10px"
                >
                  <div style="background-color: white; width: 30%;">
                    <v-select
                      :value="searchCategory"
                      :options="categories"
                      :reduce="categories => categories.key"
                      @input="setCategory"
                    />
                  </div>
                  <div style="width: 70%;">
                    <input
                      type="text"
                      v-model="searchText"
                      placeholder="Search"
                      style="height: 100%; width: 100%;"
                    />
                  </div>
                </div>
                <div>
                  <CustomerTable
                    v-if="companyData"
                    :customerData="params.data"
                    :config="config"
                    :companies="companyData"
                    :style="{ height: '600px' }"
                  />
                </div>
                <div style="display: flex; justify-content: flex-end;">
                  <div style="padding-top: 8px; margin-right: -30px">
                    <v-select
                      :value="perPage"
                      :options="pageSizes"
                      @input="setSelected"
                    />
                  </div>
                  <div style="padding-right: 10px; margin-left: 0;">
                    <pagination
                      :totalPages="Math.ceil(parseInt(pagination) / perPage)"
                      :perPage="perPage"
                      :currentPage="currentPage"
                      @pagechanged="onPageChange"
                    />
                  </div>
                </div>
                <div class="text-right md-layout-item md-size-100">
                  <md-button class="md-raised md-success" @click="download">
                    <md-icon>download </md-icon>
                    <md-tooltip md-direction="top">Download as CSV</md-tooltip>
                  </md-button>
                </div>
              </template>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
    <div class="loading-overlay" v-if="loading">
      <md-progress-spinner
        md-mode="indeterminate"
        :md-stroke="2"
      ></md-progress-spinner>
    </div>
    <div class="loading-bar-overlay" v-if="loading_bar">
      <div class="loading-bar">
        <md-progress-bar md-mode="query"></md-progress-bar>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/services/ApiService";
import CustomerTable from "@/components/CustomerTable";
import Pagination from "@/pages/Pagination.vue";
import { exportCSV } from "@/utils/ListUtils";
import moment from "moment";

export default {
  components: {
    CustomerTable,
    Pagination
  },
  props: {
    tableHeaderColor: {
      type: String,
      default: "green"
    }
  },
  data() {
    return {
      loading: false,
      loading_bar: false,
      companies: [],
      companyData: [],
      input: "",
      searchText: "",
      isTyping: false,
      categories: [
        {
          key: "name",
          label: "Company Name"
        },
        {
          key: "email_confirmation_sent",
          label: "Registration date"
        },
        {
          key: "free_period_days",
          label: "Trial period"
        },
        {
          key: "coupons_expiry",
          label: "Campaign period"
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "pricing_plan",
          label: "Plan"
        },
        {
          key: "number",
          label: "050 Number"
        },
        {
          key: "CardNo",
          label: "Registered credit card"
        },
        {
          key: "companynamephonetic",
          label: "Pronunciation"
        },
        {
          key: "template_data.slackChannel",
          label: "Slack Notification"
        },
        {
          key: "template_data.emailAddress",
          label: "Email Notification"
        },
        {
          key: "template_data.smsNumbers",
          label: "SMS Notification"
        },
        {
          key: "email",
          label: "Contact Email"
        },
        {
          key: "companyaddress",
          label: "Address"
        },
        {
          key: "city",
          label: "City"
        },
        {
          key: "postcode",
          label: "Postal Code"
        },
        {
          key: "friendlyname",
          label: "Person In Charge"
        },
        {
          key: "personemail",
          label: "PIC (email)"
        },
        {
          key: "personphonenumber",
          label: "PIC (phone number)"
        },
        {
          key: "campaign_code_data.code",
          label: "Campaign code"
        },
        {
          key: "username",
          label: "Login ID"
        },
        {
          key: "voice",
          label: "Voice"
        },
        {
          key: "gmo_member_id",
          label: "GMO Number"
        },
        {
          key: "trial_email_title",
          label: "Email Title"
        },
        {
          key: "trial_email_sent",
          label: "Email sending date"
        }
      ],
      searchCategory: "name",
      config: [
        {
          key: "name",
          label: "Name",
          type: "text"
        },
        {
          key: "loginID",
          label: "Login ID",
          type: "text"
        }
      ],
      params: {
        data: []
      },
      pagination: 0,
      currentPage: 1,
      perPage: 50,
      pageSizes: [10, 20, 30, 40, 50]
    };
  },
  mounted() {
    this.fetchCustomer();
  },
  watch: {
    searchText: function(val) {
      if (!this.isTyping) {
        setTimeout(() => {
          this.fetchCustomer();
          this.isTyping = false;
        }, 1000);
      }
      this.currentPage = 1;
      this.isTyping = true;
    }
  },
  methods: {
    async fetchCustomer() {
      this.loading = true;
      var response = await ApiService.fetchMayaiDetailsWithPagination(
        this.currentPage,
        this.perPage,
        this.searchText,
        this.searchCategory
      );
      if (response.data) {
        if (typeof response.data.customers[0].metadata[0] !== "undefined") {
          this.pagination = response.data.customers[0].metadata[0].total;
        }
        this.loading = false;
        this.params.data = [];
        this.companyData = response.data.customers[0].data;
        this.companyData.forEach(comp => {
          var user_data = "";
          if (comp.user_data) {
            user_data = comp.user_data.username;
          }
          this.params.data.push({ name: comp.name, loginID: user_data });
        });
      } else {
        this.loading = false;
      }
    },
    async mapExportableData() {
      var responce = await ApiService.fetchMayaiDetailsAll();
      this.companies = responce.data.customers;
      this.active = 0;
      this.inactive = 0;
      let data = [];
      if (this.companies) {
        data.push([
          "Company Name",
          "Registration date",
          "Trial period",
          "Campaign period",
          "Status",
          "Plan",
          "050 Number",
          "Registered credit card",
          "Pronunciation",
          "Notification Destination",
          "Contact Email",
          "Address",
          "City",
          "Postal Code",
          "Person In Charge",
          "PIC (email)",
          "PIC (phone number)",
          "Campaign code",
          "Login ID",
          "Voice",
          "GMO Number",
          "Email Title",
          "Email sending date"
        ]);
        // data.push(['Company Name', 'Status', 'Plan','Number','No Of Calls']);
        this.companies.forEach(async comp => {
          var settings_data = comp.settings_data;
          var notification = "";
          if (settings_data && settings_data.template_data) {
            if (
              settings_data.template_data.useEmail &&
              settings_data.template_data.emailAddress.length > 0
            ) {
              notification = settings_data.template_data.emailAddress.join(";");
            } else if (settings_data.template_data.useSlack) {
              notification =
                settings_data.template_data.slackChannel + " (Slack)";
            }
          }
          var address = "";
          var city = "";
          var postcode = "";
          if (comp.companyaddress) {
            address = comp.companyaddress;
          } else if (comp.address) {
            address =
              comp.address.address1 +
              " " +
              comp.address.address2 +
              " " +
              comp.address.prefecture;
            address = address.replace("undefined", "");
            city = comp.address.city;
          }
          if (comp.postcode) {
            postcode = comp.postcode;
          }
          var status = comp.status;
          if (comp.status === "active") {
            this.active++;
            status = "Active";
          } else if (comp.status === "inactive") {
            this.inactive++;
            status = "Sleep";
          } else if (comp.status === "cancelled") {
            status = "Cancel";
          }
          // var coupons = [];
          var coupon_codes = "";
          var coupons_expiry = "";
          if (comp.coupons && comp.coupons.length > 0) {
            // Coupons inside companies collection
            var coupons_data = comp.coupon_data; //Data from coupons collection
            if (comp.coupons.length == 1) {
              coupon_codes = coupons_data[0].COUPON_CODE;
              coupons_expiry =
                comp.coupons[0].expiry !== 0
                  ? moment(comp.coupons[0].expiry).format("YYYY/MM/DD")
                  : "Never expires";
            } else {
              for (var i = 0; i < comp.coupons.length; i++) {
                var expiry =
                  comp.coupons[i].expiry !== 0
                    ? moment(comp.coupons[i].expiry).format("YYYY/MM/DD")
                    : "Never expires";
                var coupon = coupons_data.filter(
                  c => c._id === comp.coupons[i].coupon_id
                );

                if (coupon && coupon.length > 0)
                  coupon_codes =
                    coupon_codes +
                    " (" +
                    (i + 1) +
                    ") " +
                    coupon[0].COUPON_CODE;

                coupons_expiry =
                  coupons_expiry + " (" + (i + 1) + ") " + expiry;

                // coupons.push({ code: coupon[0].COUPON_CODE, expiry: expiry });
              }
            }
          }
          var signup_date_str = "";
          if (comp.email_confirmation_sent) {
            signup_date_str = moment(comp.email_confirmation_sent).format(
              "YYYY/MM/DD"
            );
          } else {
            signup_date_str = moment(comp.signup_date).format("YYYY/MM/DD");
          }
          var signup_date = moment(comp.signup_date).format("YYYY/MM/DD");
          var trial_period = comp.free_period_days ? comp.free_period_days : 0;
          if (trial_period) {
            trial_period =
              signup_date +
              "-" +
              moment(comp.signup_date)
                .add(trial_period, "days")
                .format("YYYY/MM/DD");
          }

          var user_data = "";
          var friendlyname = "";
          var personemail = "";
          var personphonenumber = "";
          if (comp.user_data) {
            // User data inside companies collection
            user_data = comp.user_data.username;
            friendlyname = comp.user_data.friendlyname;
            personemail = comp.user_data.personemail;
            personphonenumber = comp.user_data.personphonenumber;
          }
          var voice = "";

          if (comp.agent && comp.engine) {
            voice = comp.agent + "-" + comp.engine;
          } else if (comp.agent) {
            voice = comp.agent;
          } else {
            voice = comp.engine;
          }

          if (comp.trial_email_sent) {
            var email_send_date = moment(comp.trial_email_sent).format(
              "YYYY/MM/DD"
            );
          }
          data.push([
            comp.name,
            signup_date_str,
            trial_period,
            coupons_expiry,
            status,
            comp.pricing_plan,
            comp.number,
            comp.payment_method == 1 ? "Yes" : "No",
            comp.companynamephonetic,
            notification,
            comp.email,
            address,
            city,
            postcode,
            friendlyname,
            personemail,
            personphonenumber,
            coupon_codes,
            user_data,
            voice,
            comp.gmo_member_id,
            comp.trial_email_title,
            email_send_date
          ]);
        });
      }
      return data;
    },
    async download() {
      this.loading_bar = true;
      exportCSV(await this.mapExportableData());
      this.loading_bar = false;
    },
    getData(row) {
      if (!this.companies[row]) return false;
      return this.companies[row] || { _id: "" };
    },
    changePage(pageNumber) {
      this.currentPage = pageNumber;
      this.fetchCustomer();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.fetchCustomer();
    },
    setCategory(category) {
      if (category === null) {
        this.searchCategory = "name";
      } else {
        this.searchCategory = category;
      }
    },
    setSelected(value) {
      if (value === null) {
        console.log("here");
        this.perPage = 50;
        this.currentPage = 1;
        this.fetchCustomer();
      } else {
        this.perPage = value;
        this.currentPage = 1;
        this.fetchCustomer();
      }
    }
  }
};
</script>

<style>
body {
  font-family: Helvetica, sans-serif;
  font-weight: 400;
}
#myInput {
  background-position: 10px 10px;
  background-repeat: no-repeat;
  width: 30%;
  font-size: 12px;
  padding: 12px 20px 12px 30px;
  border: 1px solid #ddd;
  margin-bottom: 12px;
}
.search-container {
  position: relative;
  height: 50px;
  width: 100%;
  background-color: aqua;
}
.search-dropdown {
  width: 250px;
  font-size: 16px;
  border: 1px solid #cccccc;
  padding: 0px;
  position: relative;
  float: left;
  border-right: 0px;
  background: #ffffff;
  background-size: 6px 6px;
  cursor: pointer;
  height: 40px;
}
.search-input {
  height: 100%;
  width: 100%;
}
.loading-bar {
  display: inline;
  z-index: 11;
  position: relative;
  top: 50%;
}
.loading-bar-overlay {
  align-items: center;
  justify-content: center;
  z-index: 10;
  background: rgba(255, 255, 255, 0.9);
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: fixed;
}
</style>